const eventEn = {
    event: require('../../lang/en/event/Event').default,
};

export default eventEn;